import { Component, Inject, Injector, isDevMode, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormBuilder, UntypedFormControl } from '@angular/forms';
import { ToastService } from 'src/app/services/toast/toast.service';
import { DocumentService } from 'src/app/services/api/document.service';
import { CommonService } from 'src/app/services/api/common.service';
import { MasterCommon } from 'src/app/models/masters/master-common';
import { MasterService } from 'src/app/services/api/masters.service';
import { StorageService } from 'src/app/services/utils/storage.service';
import { Router } from '@angular/router';
import { CommonListResponse } from 'src/app/models/common-list-response';
import { Document } from 'src/app/models/documents/document';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import { Report } from 'src/app/models/expedients/report';
import { DocFilters } from 'src/app/models/documents/doc-filters';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@vex/animations/stagger.animation';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Observable, ReplaySubject, filter } from 'rxjs';
import { ReceiversDialogComponent } from 'src/app/pages/apps/common-dialogs/receivers-dialog/receivers-dialog.component';
import { KeyValue } from 'src/app/models/key-value';
import { Entity } from 'src/app/models/contacts/entity';
import { Base64 } from 'src/app/models/documents/base64';


@Component({
  selector: 'vex-reports-history-table',
  templateUrl: './reports-history-table.component.html',
  styleUrls: ['./reports-history-table.component.scss'],
  animations: [
      fadeInUp400ms,
      stagger40ms,
      trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({
          height: '*',
          minHeight: ''
        })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ])
    ],
})
export class ReportsHistoryTableComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
    private router: Router,
    private dialogRef: MatDialogRef<ReportsHistoryTableComponent>,
    private fb: FormBuilder,
    private injector: Injector,
    private dialog: MatDialog,
    private alert: ToastService,
    private documentService: DocumentService,
    private commonService: CommonService<any, any>,
    private masterService: MasterService<MasterCommon>,
    private storageService: StorageService) {
      this.dataSource = new MatTableDataSource();
      this.documentsDataSource = new MatTableDataSource();
    }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }

  get visibleDocumentColumns() {
    return this.documentColumns.filter(column => column.visible).map(column => column.property);
  }
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  
  service: string = 'documents/report';
  reports: Report[];

  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  documentsDataSource: MatTableDataSource<any> = new MatTableDataSource();
  subject$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  data$: Observable<any[]> = this.subject$.asObservable();
  searchCtrl = new UntypedFormControl();
  items: any[] = [];
  expandedElement: Document | null;
  expandedDocument: Document | null;

  brokerList: Array<KeyValue>;

  columns: TableColumn<Report>[];
  documentColumns: TableColumn<Document>[];
  filters: DocFilters = new DocFilters();
  pageSize = 5;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 20, 50];
  order = "desc";
  orderType = "";

  ngOnInit() {

    (async () => {

      this.loadData();

      this.columns = [
        { label: ' ', property: 'expandIni', type: 'expand', visible: true },
        { label: 'Nº Tracking', property: 'tracking', type: 'text', visible: true, },
        { label: 'Enviado', property: 'isSent', type: 'flag', visible: true },
        { label: 'Fecha de envío', property: 'sentDate', type: 'date', visible: true },
        { label: 'Creado', property: 'createdAt', type: 'date', visible: true },
        { label: 'Acciones', property: 'actions', type: 'button', visible: true },
      ];

      this.documentColumns = [
        { label: ' ', property: 'expandDoc', type: 'expand', visible: true },
        { label: 'Nombre', property: 'name', type: 'text', visible: true, },
        { label: 'Categoría', property: 'documentCategory', type: 'select', visible: true },
        { label: 'Fecha de subida', property: 'createdAt', type: 'date', visible: true },
      ];

      const entities = await this.masterService.getAll("entities") as unknown as Array<Entity>;
      this.brokerList = entities.filter(x => x.entityType?.name == 'Broker').map(x => new KeyValue(x));
      
    })();
  }

  loadData() {
    this.loadFilters();
    this.getData();

    this.dataSource = new MatTableDataSource();
    this.documentsDataSource = new MatTableDataSource();

    this.data$.pipe(
      filter<any[]>(Boolean)
    ).subscribe(items => {
      this.items = items;
      this.dataSource.data = this.items;
      // EEC-059: la paginación es del servidor. Con el paginador enlazado, MatTableDataSource
      // recortaba en cliente la página recibida y fijaba length al tamaño de esa página.
      this.dataSource.sortingDataAccessor = (obj: any, property: string) =>
        property.split('.').reduce((o, p) => o && o[p], obj);
      this.dataSource.sort = this.sort;

    });

    this.searchCtrl.valueChanges.subscribe(value => this.onFilterChange(value));
  }

  getData() {
    this.commonService.reports<CommonListResponse<Document>>(this.service + '/history', this.filters).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No se ha podido cargar el histórico");
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            
            this.reports = response.data.map(r => new Report(r));
            this.paginator.length = response.total;
            this.paginator.pageIndex = this.pageIndex;
            this.subject$.next(this.reports);

          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No se ha podido cargar el histórico");
        }
    });
  }

  loadFilters() {
    this.filters.pageNumber = this.pageIndex + 1;
    this.filters.rowsPerPage = this.pageSize;
    this.filters.referenceId = this.defaults.values;
    this.filters.order = this.order;
    this.filters.orderBy = this.orderType;
  }

  loadDocuments(element: Report, expandedElement: Report) {
    this.expandedDocument = null;
    if (expandedElement && element.id === expandedElement.id) {
      const documents = element.documents || [];
      this.documentsDataSource.data = documents;
    }
  }
  
  onFilterChange(value: string) {
    if (!this.dataSource) {
      return;
    }
    value = value.trim();
    value = value.toLowerCase();
   
    this.dataSource.filter = value;
  }

  sortData(event) {
    this.orderType = event.active;
    this.order = event.direction;
    this.loadData();
  }

  onPaginateChange(event) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadData()
    const top = document.getElementById('top');
    top.scrollIntoView();
  }

  trackByProperty(index: number, column: any): string {
    return column?.property;
  }

  export(element, prev: boolean) {

    // Se manda una COPIA, no la fila. El endpoint espera en `id` el expediente, y el del
    // informe va aparte en `reportId`, que es con lo que el back fecha la cabecera de una
    // reimpresión del histórico. Mutando la fila se perdía su id, y el envío posterior
    // acababa mandando el del expediente como `reportId`.
    const payload = {
      ...element,
      // Previsualizar y descargar son caminos distintos para el back: la
      // previsualización enseña lo que se obtendría al enviar y fecha con hoy los
      // documentos que aún no constan enviados, y la descarga los deja en blanco.
      // Mandando `true` siempre, el servidor no podía distinguirlos.
      preview: prev,
      id: element.adminFileId,
      reportId: element.id,
      language: this.defaults.receivers?.client?.[0]?.language?.name || 'en',
    };

    this.commonService.reports<Base64>(this.service + '/export', payload).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No se ha podido exportar el archivo");
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            if (prev) {

              Object.values(response.data).forEach(file => {

                var newFile = this.base64toBlob(file['base64'], file['mimeType']);
                const fileURL = URL.createObjectURL(newFile);
                  
                if (file['mimeType'] != 'application/vnd.ms-excel') {
                  
                  window.open(fileURL, '_blank');

                }
              });

            } else {

              Object.values(response.data).forEach(file => {
                
                var newFile = this.base64toBlob(file['base64'], file['mimeType']);
                var fileURL = URL.createObjectURL(newFile);
                var anchor = document.createElement("a");
                anchor.download = file['fileName'];
                anchor.href = fileURL;
                anchor.click();

              });
            }
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No se ha podido exportar el archivo");
        }
    });
  }

  send(element) {

    this.dialog.open(ReceiversDialogComponent, {
      data: {
        data: this.defaults.receivers,
        tracking: element.tracking
      }
    })
    .afterClosed().subscribe((result) => {

      if (!result) {
        if (result !== '') this.alert.error("No se han identificado destinatarios");
        return;
      }

      // Igual que en export: una copia, para no dejar la fila con el id del expediente.
      const payload = {
        ...element,
        user: result.user,
        receiver: result.receiver,
        sendMessage: result.sendMessage,
        reportId: element.id,
        language: result.language,
        id: this.defaults.values,
      };

      this.commonService.reports<CommonListResponse<Document>>(this.service + '/send', payload).subscribe({
        next:
          response => {
            if (!response) {
              this.alert.error("No se ha podido enviar el archivo");
            }
            else if (!response.isSuccessful) {
              this.alert.info(response.message);
            }
            else {
              this.alert.info("Informe enviado");
              this.loadData();
            }
          },
        error:
          (e) => {
            if (e.status == '401') {
              this.router.navigate(['/login']);
              this.alert.info("Sesión expirada")
              return;
            }
            if (isDevMode)
              this.alert.error(e.message)
            else
              this.alert.error("No se ha podido enviar el archivo");
          }
      });
    });
  }

  base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

}
